if ( Element && !Element.prototype.matches )
{
	main();
}

function main(): void
{
	const proto: any = Element.prototype;
	
	proto.matches = proto.matchesSelector
		|| proto.mozMatchesSelector
		|| proto.msMatchesSelector
		|| proto.oMatchesSelector
		|| proto.webkitMatchesSelector
		|| matches;
}

​function matches( selector: string ): boolean
{
	const element: Element = this;
	
	const matches: NodeList = element.ownerDocument.querySelectorAll( selector );
	let i: number = matches.length;
	
	while (
		( --i >= 0 )
		&& ( matches.item( i ) !== element )
	);
	
	return i > -1;
}
